import { useSelector } from "react-redux";
import { memo } from "react";
import { selectAdvancedTranslation } from "~/features/configurator/Linear/redux/selectors";
import { Translation } from "~/app/i18n/Translation";

interface Props {
  translationKey: string;
}

// @ts-ignore
export const LinearTranslation = memo(({ translationKey }: Props) => {
  const translation = useSelector(selectAdvancedTranslation(translationKey));

  if (!translation) {
    return null;
  }

  return <Translation {...translation} />;
});
